import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_PLANS = `${API_URL}/plans/getAllPlans`;
const GET_ALL_MEMBER_PLANS = `${API_URL}/memberPlans/getAllMemberPlans`;
const GET_ALL_PRODUCTS = `${API_URL}/products`;

export const getAllPlans = async (params:any) => {
    try {
        const { data } = await axios.get(GET_ALL_PLANS,{params});
        return data;
    } catch (error: any) {
        return error;
    }
}

export const getAllMemberPlans = async (params:any) => {
    try {
        const { data } = await axios.get(GET_ALL_MEMBER_PLANS,{params});
        return data;
    } catch (error: any) {
        return error;
    }
}

export const getAllProducts = async () => {
    try {
        const { data } = await axios.get(GET_ALL_PRODUCTS);
        return data;
    } catch (error: any) {
        return error;
    }
}